import { render, staticRenderFns } from "./update-accessory-modal.vue?vue&type=template&id=064b4ff4"
import script from "./update-accessory-modal.vue?vue&type=script&lang=js"
export * from "./update-accessory-modal.vue?vue&type=script&lang=js"
import style0 from "./update-accessory-modal.vue?vue&type=style&index=0&id=064b4ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports